import React from 'react';
import { BookOpenCheck, Zap, ClipboardList, Gift, ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { motion } from 'framer-motion';
const benefits = [{
  icon: BookOpenCheck,
  label: 'Recibí material digital'
}, {
  icon: Zap,
  label: 'Accedé al instante'
}, {
  icon: ClipboardList,
  label: 'Usá la masterclass y la guía'
}, {
  icon: Gift,
  label: 'Sumá tres bonos'
}];
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const scrollToProduct = () => {
    document.getElementById('contenido')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative overflow-hidden bg-brand-lighter px-6 pb-20 pt-24 lg:px-8" data-id="element-122">
      <div className="mx-auto max-w-4xl text-center" data-id="element-123">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-4xl font-extrabold leading-tight tracking-tight text-brand-navy md:text-6xl" data-id="element-124">
          Nadie te enseñó a cobrar ni a ordenar un negocio. Eso tiene solución.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mx-auto mt-6 max-w-3xl text-lg font-medium leading-relaxed text-brand-navy/75 md:text-xl" data-id="element-125">
          Un sistema para trabajar con orden y cobrar sin justificarte
        </motion.p>

        <p className="mt-3 text-sm text-brand-navy/50" data-id="element-126">
          +15 profesionales ya lo aplicaron
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.18
      }} className="my-10 grid grid-cols-1 gap-3 text-left sm:grid-cols-2" data-id="element-127">
          {benefits.map(({
          icon: Icon,
          label
        }) => <div key={label} className="flex items-center gap-3 rounded-xl border border-brand-light bg-white px-4 py-3 text-sm font-semibold text-brand-navy shadow-sm" data-id="element-128">
              <Icon className="h-5 w-5 shrink-0 text-brand-accent" data-id="element-129" />
              {label}
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.26
      }} className="flex flex-col items-center gap-4" data-id="element-130">
          <button onClick={scrollToPricing} className="w-full rounded-xl bg-brand-accent px-8 py-4 text-lg font-extrabold text-white shadow-soft-lg transition hover:-translate-y-0.5 hover:bg-blue-700 sm:w-auto" data-id="element-131">
            Quiero el Megapack PRO
          </button>
          <button onClick={scrollToProduct} className="font-bold text-brand-accent underline-offset-4 transition hover:underline" data-id="element-132">
            Ver qué incluye
          </button>

          <div className="mt-2 flex flex-wrap justify-center gap-x-5 gap-y-3 text-sm font-semibold text-brand-navy/65" data-id="element-133">
            <span className="flex items-center gap-1.5" data-id="element-134">
              <ShieldCheck className="h-4 w-4 text-brand-green" data-id="element-135" /> Garantía de
              21 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-136">
              <Lock className="h-4 w-4 text-brand-accent" data-id="element-137" /> Pago protegido
            </span>
            <span className="flex items-center gap-1.5" data-id="element-138">
              <CreditCard className="h-4 w-4 text-brand-accent" data-id="element-139" /> Mercado Pago
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}